import { Route } from "@angular/router";

export const sucursalRoutes: Route[] = [
  {
    path: 'list',
    loadComponent: () => import('./pages/sucursal-list/sucursal-list.component').then(m => m.SucursalListComponent),
  },
  {
    path: 'new',
    loadComponent: () => import('./pages/new-sucursal/new-sucursal.component').then(m => m.NewSucursalComponent),
  },
  {
    path: 'new-masive',
    loadComponent: () => import('./pages/new-sucursal-masive/new-sucursal-masive.component').then(m => m.NewSucursalMasiveComponent),
  },
  {
    path: 'new-canal',
    loadComponent: () => import('./pages/canales/canales.component').then(m => m.CanalesComponent),
  },
  {
    path: '**',
    redirectTo: 'list'
  }
]